"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "selectCurrentTab", {
  enumerable: true,
  get: function get() {
    return _selectCurrentTab["default"];
  }
});
var _selectCurrentTab = _interopRequireDefault(require("./selectCurrentTab"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }